/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Academic_Title_LabelInputs */

const en_candidate_profile_academic_title_label = /** @type {(inputs: Candidate_Profile_Academic_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Academic Title`)
};

const de_candidate_profile_academic_title_label = /** @type {(inputs: Candidate_Profile_Academic_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akademischer Titel`)
};

/**
* | output |
* | --- |
* | "Academic Title" |
*
* @param {Candidate_Profile_Academic_Title_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_academic_title_label = /** @type {((inputs?: Candidate_Profile_Academic_Title_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Academic_Title_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_academic_title_label(inputs)
	return en_candidate_profile_academic_title_label(inputs)
});